export enum ApiErrorCode {
  UnknownError = 'UNKNOWN_ERROR',
  UniqueConstraintViolation = '10000',
  FieldNameMustBeUniquePerTenant = '10005',
  FieldMaxClientMarketDepthMustBeInRange = '10004',
}

export interface IApiErrorParamsPayload {
  key: string;
  [key: string]: string | number;
}

export interface IApiErrorParams {
  status: number;
  errorCode: string;
  description?: string;
  params?: IApiErrorParamsPayload;
}

export interface IApiRejectedRecord {
  index?: number;
  name?: string;
  errorDescription: string;
  params?: IApiErrorParamsPayload;
}

export interface IApiErrorWithRejectedRecords extends IApiErrorParams {
  rejectedRecords: IApiRejectedRecord[];
}

export interface IApiErrorRes<T extends IApiErrorParams = IApiErrorParams> {
  error: T;
}
